import { Box, Header, Text } from '@rbilabs/universal-components';

import { theme } from 'styles/configure-theme';

export const AddressContainer = Box.withConfig({
  width: {
    base: 'full',
    md: '60%',
  },
  paddingY: '$4',
  paddingX: '$6',
  justifyContent: 'center',
  borderStyle: 'solid',
  borderBottomWidth: '1px',
  borderColor: Styles.color.grey.four,
  backgroundColor: theme.token('background-pattern'),
  flex: 1,
  _web: {
    alignSelf: 'center',
  },
});

export const ButtonContainer = Box.withConfig({
  marginY: '$12',
  paddingX: '$4',
  width: {
    base: 'full',
    md: '50%',
  },
  _web: {
    alignSelf: 'center',
  },
});

export const InfoContainer = Box.withConfig({
  marginLeft: '$4',
});

export const AddressInfoLine = Header.withConfig({
  variant: 'headerThree',
  margin: '0',
});

export const InfoLine = Text.withConfig({
  variant: 'copyOne',
});

export const DeliveryInfoContainer = Box.withConfig({
  marginTop: '$6',
  marginX: 'auto',
  maxWidth: {
    base: '$64',
    md: 'full',
  },
});
